// Add your custom JS here.
(function () {
	function displayMenu() {
		var $t = $(this);
		$t.toggleClass("collapsed");
		$("#menu").slideToggle();
	}
	function displayMenuDesktop() {
		var $t = $(this);
		if ($t.hasClass("menu-item-products")) {
			$("#menu").slideDown();
		} else {
			$("#menu").slideUp();
		}
	}

	function addProductToCompare() {
		var $t = $(this);
		var compare_grid = $(".compare-grid:not(.compare-grid-modal)");
		var current_product = $t.closest(".compare-product");
		current_product
			.clone()
			.appendTo(compare_grid)
			.addClass("compare-product-add");

		$(".btn-compare-add").hide();
		$(".btn-reset").show();
		$("#compare-modal .btn-close").trigger("click");
		$(".btn-compare").removeAttr("disabled");

		let consumption_input = $("#consumption-electric");
		if (consumption_input) {
			var consumption = $t
				.closest(".compare-product")
				.find("input[name=compare-consumption]")
				.val();
			consumption = parseFloatConsumption(consumption);

			consumption_input.val(consumption);
			calcConsumption();
		}
	}

	function resetProductCompare() {
		var $t = $(this);
		$(".compare-product-add").remove();
		$(".btn-compare-add").show();
		$t.hide();
		$(".input-change").val(0);
		calcConsumption();
	}

	function filterPrice() {
		var $t = $(this);
		var max_price = $t.val();
		var range_price = $("#filter-price-input");
		var max_price_input = $("#max_price-input");
		max_price_input.val(max_price);
		range_price.val(max_price);
	}

	function submitFilterForm() {
		document.getElementById("form-filter").submit();
	}

	function addAttributeValueOnChange() {
		var $t = $(this);
		var $checks = $t
			.closest(".filter-attributes")
			.find(".input-filter-attribute");
		var values = $checks
			.filter(":checked")
			.map(function () {
				return this.value;
			})
			.get();
		let input_attribute = $t
			.closest(".accordion-filter-attribute")
			.find(".input-attribute");
		input_attribute.val(values);
	}
	function changeUrlFormOnChange() {
		var form_filter = $("#form-filter");
		var url_shop = form_filter.data("url");
		var $t = $(this);
		if ($t.is(":checked")) {
			form_filter.attr("action", $t.val());
		} else {
			form_filter.attr("action", url_shop);
		}
	}

	// calculator
	function parseFloatConsumption(consumption) {
		return parseFloat(consumption.replace(/\D+$/g, "").replace(",", "."));
	}

	function calcConsumption() {
		calcConsumptionElectric("electric");
		calcConsumptionCombustion("combustion");
		calcDifference();
	}

	function calcConsumptionElectric(type) {
		$(`#cost-per-km-${type}`).val(calcCostPerKm(type).toFixed(2));
		$(`#cost-week-${type}`).val(calcCostPerWeek(type).toFixed(2));
		$(`#cost-month-${type}`).val(calcCostPerMonth(type).toFixed(2));
		$(`#cost-year-${type}`).val(calcCostPerYear(type).toFixed(2));
	}
	function calcConsumptionCombustion(type) {
		$(`#cost-per-km-${type}`).val((calcCostPerKm(type) / 100).toFixed(2));
		$(`#cost-week-${type}`).val((calcCostPerWeek(type) / 100).toFixed(2));
		$(`#cost-month-${type}`).val(calcCostPerMonth(type).toFixed(2));
		$(`#cost-year-${type}`).val(calcCostPerYear(type).toFixed(2));
	}

	function calcDifference() {
		$(`#saving-week`)
			.val(differenceWeek().toFixed(2))
			.removeClass("cheap expensive")
			.addClass(isExpensiveOrCheap(differenceWeek()));
		$(`#saving-month`)
			.val(differenceMonth().toFixed(2))
			.removeClass("cheap expensive")
			.addClass(isExpensiveOrCheap(differenceMonth()));
		$(`#saving-year`)
			.val(differenceYear().toFixed(2))
			.removeClass("cheap expensive")
			.addClass(isExpensiveOrCheap(differenceYear()));
	}

	function calcCostPerKm(type) {
		return (
			parseFloatConsumption($(`#consumption-${type}`).val()) *
			parseFloatConsumption($(`#price-${type}`).val())
		);
	}

	function calcCostPerWeek(type) {
		return (
			parseFloatConsumption($(`#consumption-${type}`).val()) *
			parseFloatConsumption($(`#price-${type}`).val()) *
			parseFloatConsumption($("#km-week").val())
		);
	}
	function calcCostPerMonth(type) {
		return $(`#cost-week-${type}`).val() * 4;
	}
	function calcCostPerYear(type) {
		return $(`#cost-month-${type}`).val() * 12;
	}

	function differenceWeek() {
		return $(`#cost-week-combustion`).val() - $(`#cost-week-electric`).val();
	}
	function differenceMonth() {
		return $(`#cost-month-combustion`).val() - $(`#cost-month-electric`).val();
	}
	function differenceYear() {
		return $(`#cost-year-combustion`).val() - $(`#cost-year-electric`).val();
	}

	function isExpensiveOrCheap(value) {
		if (value > 0) {
			return "cheap";
		} else if (value < 0) {
			return "expensive";
		}
	}

	function changeFeaturedImageOnVariations() {
		var form = $(".variations_form");
		// aplico timeout de 30 para forzar el cambio porque Woocommerce lo establece en 20.
		setTimeout(function () {
			var variation_image_id = form.attr("current-image");
			if (variation_image_id) {
				var item = $(`#${variation_image_id}`).closest(".owl-item");
				var position = item.prevAll().length;
				$(".product-gallery").trigger("to.owl.carousel", [position, 1]);
			} else {
				$(".product-gallery").trigger("to.owl.carousel", [0, 1]);
			}
		}, 30);
	}

	function filterConcessionairesByProvince() {
		var $t = $(this);
		var province = $t.val();
		if (province) {
			$(".card-concessionaires").hide();
			var cardsByProvince = $(".card-concessionaires").filter(
				`[data-province='${province}']`
			);
			cardsByProvince.show();

			var results = cardsByProvince.length;
			var emptyResults = $(".concessionaries-results");
			if (results == 0) {
				emptyResults.show();
			} else {
				emptyResults.hide();
			}
		} else {
			$(".card-concessionaires").show();
		}
	}

	$(function () {
		$(".btn-hamburger").on("click", displayMenu);
		$(".btn-add-product-to-compare").on("click", addProductToCompare);
		$(".btn-reset").on("click", resetProductCompare);

		$(".input-change").on("change", calcConsumption);

		$("#filter-price-input, #max_price-input").on("change", filterPrice);
		$("#form-filter .btn-submit").on("click", submitFilterForm);
		$(".input-filter-attribute").on("change", addAttributeValueOnChange);
		$(".filter-categories-input").on("change", changeUrlFormOnChange);

		$(".select-variations").on("change", changeFeaturedImageOnVariations);

		$(".select-province").on("change", filterConcessionairesByProvince);

		if ($(window).width() >= 992) {
			$("#menu-desktop .menu-item").on("mouseenter", displayMenuDesktop);
			$("#menu").on("mouseleave", function () {
				$("#menu").slideUp();
			});
		}
	});
}).call(this);
